module.exports = __webpack_public_path__ + "img/icon-add-new.0887b04d.svg";